export const remindersQueryKeys = {
    all: ["reminders"] as const,
    list: () => ["reminders", "list"] as const,
}